<template>
  <div>
    <head>
      <meta charset="utf-8"/>
      <meta content="width=device-width, initial-scale=1.0" name="viewport">
      <meta content="Rental management system by Nouveta LTD" name="description"/>
      <meta content="Kelvin Njuguna" name="author"/>
      <!-- App favicon -->
      <link href="assets/images/favicon.png" rel="shortcut icon">
      <!-- droping file -->
      <link
          href="assets/libs/dropzone/min/dropzone.min.css"
          rel="stylesheet"
          type="text/css"
      />

      <!-- DataTables -->
      <link
          href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css"
          rel="stylesheet"
          type="text/css"
      />
      <link
          href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css"
          rel="stylesheet"
          type="text/css"
      />

      <!-- Bootstrap Css -->
      <link
          href="assets/css/bootstrap.min.css"
          id="bootstrap-style"
          rel="stylesheet"
          type="text/css"
      />
      <!-- Bootstrap select styling -->
      <link
          href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css"
          rel="stylesheet"
      >
      <!-- Icons Css -->
      <link
          href="assets/css/icons.min.css"
          rel="stylesheet"
          type="text/css"
      />
      <!-- App Css-->
      <link
          href="assets/css/app.min.css"
          id="app-style"
          rel="stylesheet"
          type="text/css"
      />
      <!-- custom Css-->
      <link
          href="assets/css/custom.css"
          id="app-style"
          rel="stylesheet"
          type="text/css"
      />

    </head>

    <body @contextmenu.prevent data-sidebar="dark">
    <!-- Begin page -->
    <div id="layout-wrapper">
      <NavigationBar/>

      <!-- ============================================================== -->
      <!-- Start right Content here -->
      <!-- ============================================================== -->
      <div id="content" class="content-minimize">
        <div class="page-content">
          <div class="container-fluid">

            <!-- Enhanced Header Section with Purple Theme -->
            <div class="page-header-enhanced">
              <div class="header-content-wrapper">
                <div class="header-left">
                  <h1 class="page-main-title">Bills Receipted</h1>
                  <div class="breadcrumb-container">
                    <i class="bx bx-home-alt"></i>
                    <a @click="gotTo('dashboard')" class="breadcrumb-link">Dashboard</a>
                    <span class="breadcrumb-divider">/</span>
                    <span class="breadcrumb-current">Bills Receipted</span>
                  </div>
                </div>
                <div class="header-right">
                  <div class="header-stat-badge">
                    <span class="stat-number">{{numberFormat(summary.count || 0)}}</span>
                    <span class="stat-text">TOTAL RECEIPTS</span>
                  </div>
                  <div class="header-stat-badge primary">
                    <span class="stat-number">{{formatPrice(summary.total || 0)}}</span>
                    <span class="stat-text">TOTAL COLLECTED</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Summary Statistics Cards -->
            <div class="row summary-cards-row">
              <div class="col-lg-3 col-md-6">
                <div class="summary-card purple-gradient">
                  <div class="card-icon-box">
                    <i class="bx bx-receipt"></i>
                  </div>
                  <div class="card-content">
                    <h3 class="card-value">{{numberFormat(filteredBillDetails.length || 0)}}</h3>
                    <p class="card-label">DISPLAYED RECEIPTS</p>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-6">
                <div class="summary-card blue-gradient">
                  <div class="card-icon-box">
                    <i class="bx bx-file"></i>
                  </div>
                  <div class="card-content">
                    <h3 class="card-value">{{formatPrice(calculateTotal('amount'))}}</h3>
                    <p class="card-label">TOTAL INVOICED</p>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-6">
                <div class="summary-card green-gradient">
                  <div class="card-icon-box">
                    <i class="bx bx-money"></i>
                  </div>
                  <div class="card-content">
                    <h3 class="card-value">{{formatPrice(calculateTotal('amount'))}}</h3>
                    <p class="card-label">TOTAL PAID</p>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-6">
                <div class="summary-card orange-gradient">
                  <div class="card-icon-box">
                    <i class="bx bx-wallet"></i>
                  </div>
                  <div class="card-content">
                    <h3 class="card-value">{{formatPrice(0)}}</h3>
                    <p class="card-label">TOTAL BALANCE</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Main Content Card -->
            <div class="row">
              <div class="col-12">
                <div class="card main-table-card">
                  <!-- Filter Section -->
                  <div class="card-header filter-header">
                    <div class="filter-row">
                      <!-- Search Box -->
                      <div class="search-container">
                        <div class="search-input-wrapper">
                          <i class="bx bx-search"></i>
                          <input
                              v-model="search"
                              type="text"
                              class="form-control search-field"
                              placeholder="Search bills, transactions, names..."
                              @input="debounceSearch"
                          >
                          <button v-if="search" @click="clearSearch" class="btn-clear-search">
                            <i class="bx bx-x"></i>
                          </button>
                        </div>
                      </div>

                      <!-- Filter Controls -->
                      <div class="filter-controls-wrapper">
                        <!-- Payment Mode -->
                        <div class="filter-item">
                          <label class="filter-label">PAYMENT MODE</label>
                          <select v-model="paymentMode" @change="applyFilters" class="form-select filter-select">
                            <option value="">All Payments</option>
                            <option value="MPESA">MPESA</option>
                            <option value="BANK">BANK</option>
                          </select>
                        </div>

                        <!-- Filter By -->
                        <div class="filter-item">
                          <label class="filter-label">FILTER BY</label>
                          <select v-model="filter" @change="handleFilterChange" class="form-select filter-select">
                            <option value="">All Transactions</option>
                            <option value="filter-sub-county">Sub County</option>
                            <option value="filter-wards">Ward</option>
                            <option value="filter-zone">Zone</option>
                            <option value="filter-officer">County Agent</option>
                          </select>
                        </div>

                        <!-- Dynamic Filter Value Selector -->
                        <div class="filter-item" v-if="filter && itemList.length > 0">
                          <label class="filter-label">SELECT {{filterLabel}}</label>
                          <select v-model="selectedFilterValue" @change="applyFilters" class="form-select filter-select">
                            <option value="">All {{filterLabel}}s</option>
                            <option v-for="item in itemList" :key="item.id" :value="item.value">
                              {{item.value}}
                            </option>
                          </select>
                        </div>

                        <!-- Date Range -->
                        <div class="filter-item date-range-item">
                          <label class="filter-label">DATE RANGE</label>
                          <div class="date-range-inputs">
                            <input
                                v-model="dateFrom"
                                type="date"
                                class="form-control date-input"
                                @change="applyFilters"
                            >
                            <span class="date-separator">to</span>
                            <input
                                v-model="dateTo"
                                type="date"
                                class="form-control date-input"
                                @change="applyFilters"
                            >
                          </div>
                        </div>

                        <!-- Download Buttons -->
                        <div v-if="getRight('DOWNLOAD RECEIPTS')" class="filter-item">
                          <div class="download-buttons-group">
                            <button
                                @click="downloadCurrentView"
                                class="btn btn-primary btn-download"
                                :disabled="loading || downloading || filteredBillDetails.length === 0"
                            >
                              <i class="bx bx-download"></i>
                              <span>Current ({{numberFormat(filteredBillDetails.length)}})</span>
                            </button>
                            <button
                                @click="downloadAllData"
                                class="btn btn-secondary btn-download"
                                :disabled="loading || isDownloadingAll || summary.count === 0"
                            >
                              <i class="bx bx-cloud-download"></i>
                              <span v-if="isDownloadingAll">Downloading...</span>
                              <span v-else>All ({{numberFormat(summary.count)}})</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Table Body -->
                  <div class="card-body p-0">
                    <!-- Desktop Table View -->
                    <div class="table-responsive" v-if="!loading">
                      <table class="table table-hover bills-table">
                        <thead>
                        <tr>
                          <th width="3%">#</th>
                          <th width="9%">BILL NO</th>
                          <th width="14%">DESCRIPTION</th>
                          <th width="10%">PAID BY</th>
                          <th width="10%">LOCATION</th>
                          <th width="10%">INVOICED BY</th>
                          <th width="10%">RECEIPTED BY</th>
                          <th width="7%" class="text-end">INVOICED</th>
                          <th width="7%" class="text-end">PAID</th>
                          <th width="6%" class="text-end">BALANCE</th>
                          <th width="5%">PAYMENT</th>
                          <th width="5%">STATUS</th>
                          <th width="6%">DATE</th>
                          <th width="4%" class="text-center">ACTIONS</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in paginatedBillDetails" :key="item.id || index">
                          <td class="row-number">{{((currentPage - 1) * actualPageSize) + index + 1}}</td>
                          <td>
                            <div class="bill-no-cell">
                              <span class="bill-number">{{item.account_ref || item.billNo || 'N/A'}}</span>
                              <span class="transaction-code">{{item.transactionCode || item.transaction_code || ''}}</span>
                            </div>
                          </td>
                          <td>
                            <span class="description-text" :title="item.incomeTypeDescription || item.transaction_desc">
                              {{truncateText(item.incomeTypeDescription || item.transaction_desc || 'N/A', 40)}}
                            </span>
                          </td>
                          <td>
                            <div class="user-info-cell">
                              <div class="user-avatar">
                                {{getInitial(getDisplayName(item))}}
                              </div>
                              <span class="user-name">{{getDisplayName(item)}}</span>
                            </div>
                          </td>
                          <td>
                            <div class="location-info">
                              <span class="location-main">{{item.subCountyName || 'N/A'}}</span>
                              <span class="location-sub">{{item.wardName || ''}}</span>
                            </div>
                          </td>

                          <!-- Invoiced By Column -->
                          <td>
                            <div class="agent-info-cell">
                              <div class="agent-avatar invoiced">
                                {{getInitial(item.invoicedBy || item.username)}}
                              </div>
                              <div class="agent-details">
                                <span class="agent-name">{{item.invoicedBy || item.username || 'N/A'}}</span>
                                <span class="agent-phone" v-if="item.invoicedByPhoneNumber || item.userPhoneNumber">
                                  {{maskPhoneNumber(item.invoicedByPhoneNumber || item.userPhoneNumber)}}
                                </span>
                              </div>
                            </div>
                          </td>

                          <!-- Receipted By Column -->
                          <td>
                            <div class="agent-info-cell">
                              <div class="agent-avatar receipted">
                                {{getInitial(item.receiptedBy || item.username)}}
                              </div>
                              <div class="agent-details">
                                <span class="agent-name">{{item.receiptedBy || item.username || 'N/A'}}</span>
                                <span class="agent-phone" v-if="item.receiptedByPhoneNumber || item.userPhoneNumber">
                                  {{maskPhoneNumber(item.receiptedByPhoneNumber || item.userPhoneNumber)}}
                                </span>
                              </div>
                            </div>
                          </td>

                          <!-- INVOICED: use amount field -->
                          <td class="text-end">
                            <span class="invoice-amount">{{formatPrice(item.amount || 0)}}</span>
                          </td>
                          <!-- PAID: same as amount since always fully paid -->
                          <td class="text-end">
                            <span class="paid-amount">{{formatPrice(item.amount || 0)}}</span>
                          </td>
                          <!-- BALANCE: always 0 -->
                          <td class="text-end">
                            <span class="balance-amount">
                              {{formatPrice(0)}}
                            </span>
                          </td>

                          <td>
                            <span class="payment-method" :class="'payment-' + (item.source || item.payment_type || '').toLowerCase()">
                              {{item.payment_type}}
                            </span>
                          </td>
                          <td>
                            <span class="status-badge" :class="getStatusClass(item.status)">
                              <i class="bx bx-circle"></i>
                              {{item.status || 'UNPAID'}}
                            </span>
                          </td>
                          <td>
                            <span class="date-text">{{formatDate(item.dateCreated || item.date)}}</span>
                          </td>
                          <td class="text-center">
                            <div class="action-buttons">
                              <button
                                  @click="viewBillDetails(item)"
                                  class="btn btn-sm btn-icon btn-primary"
                                  data-bs-toggle="modal"
                                  data-bs-target="#billDetail"
                                  title="View Details"
                              >
                                <i class="bx bx-show"></i>
                              </button>
                              <button
                                  @click="printBill(item.account_ref || item.billNo)"
                                  class="btn btn-sm btn-icon btn-secondary"
                                  title="Print"
                              >
                                <i class="bx bx-printer"></i>
                              </button>
                              <div class="dropdown d-inline-block">
                                <button
                                    class="btn btn-sm btn-icon btn-secondary"
                                    type="button"
                                    data-bs-toggle="dropdown"
                                >
                                  <i class="bx bx-dots-vertical-rounded"></i>
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end">
                                  <li>
                                    <a class="dropdown-item" href="javascript: void(0);" @click.prevent="sendEmail(item)">
                                      <i class="bx bx-envelope me-2"></i>Send Email
                                    </a>
                                  </li>
                                  <li>
                                    <a class="dropdown-item" href="javascript: void(0);" @click.prevent="sendSMS(item)">
                                      <i class="bx bx-message me-2"></i>Send SMS
                                    </a>
                                  </li>
                                  <li v-if="getRight('void')"><hr class="dropdown-divider"></li>
                                  <li v-if="getRight('void')">
                                    <a class="dropdown-item text-danger" href="javascript: void(0);" @click.prevent="voidReceipt(item)">
                                      <i class="bx bx-trash me-2"></i>Void Receipt
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                    <!-- Loading State -->
                    <div v-if="loading" class="loading-state">
                      <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                      <h4>Loading Bills</h4>
                      <p>Fetching your receipt data...</p>
                    </div>

                    <!-- Empty State -->
                    <div v-if="!loading && filteredBillDetails.length === 0" class="empty-state">
                      <i class="bx bx-receipt empty-icon"></i>
                      <h3>No Bills Found</h3>
                      <p>{{emptyStateMessage}}</p>
                    </div>
                  </div>

                  <!-- Pagination Footer -->
                  <div class="card-footer" v-if="!loading && filteredBillDetails.length > 0">
                    <div class="pagination-wrapper">
                      <div class="pagination-info">
                        <span v-if="pageSize !== 'all'">
                          Showing {{paginationStart}} to {{paginationEnd}} of {{filteredBillDetails.length}} entries
                        </span>
                        <span v-else>Showing all {{filteredBillDetails.length}} entries</span>
                        <select v-model="pageSize" @change="handlePageSizeChange" class="form-select page-size-select">
                          <option value="10">10 per page</option>
                          <option value="25">25 per page</option>
                          <option value="50">50 per page</option>
                          <option value="100">100 per page</option>
                          <option value="200">200 per page</option>
                          <option value="500">500 per page</option>
                          <option value="1000">1000 per page</option>
                          <option value="all">All</option>
                        </select>
                      </div>

                      <nav v-if="pageSize !== 'all'">
                        <ul class="pagination">
                          <li class="page-item" :class="{disabled: currentPage === 1}">
                            <a class="page-link" @click="goToFirstPage">
                              <i class="bx bx-chevrons-left"></i>
                            </a>
                          </li>
                          <li class="page-item" :class="{disabled: currentPage === 1}">
                            <a class="page-link" @click="prevPage">
                              <i class="bx bx-chevron-left"></i>
                            </a>
                          </li>
                          <li
                              v-for="page in visiblePages"
                              :key="'page-' + page"
                              class="page-item"
                              :class="{active: page === currentPage}"
                          >
                            <a class="page-link" @click="goToPage(page)" v-if="page !== '...'">{{page}}</a>
                            <span class="page-link" v-else>...</span>
                          </li>
                          <li class="page-item" :class="{disabled: currentPage === totalPages}">
                            <a class="page-link" @click="nextPage">
                              <i class="bx bx-chevron-right"></i>
                            </a>
                          </li>
                          <li class="page-item" :class="{disabled: currentPage === totalPages}">
                            <a class="page-link" @click="goToLastPage">
                              <i class="bx bx-chevrons-right"></i>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- Download Progress Modal with Pause/Resume and Time Estimation -->
        <div class="modal fade" id="downloadProgressModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header bg-primary text-white">
                <h5 class="modal-title text-white">
                  <i class="bx bxs-download me-2"></i>Downloading All Receipts
                </h5>
              </div>
              <div class="modal-body">
                <div class="text-center mb-3">
                  <div class="spinner-border text-primary mb-3" style="width: 3rem; height: 3rem;" role="status" v-if="!downloadPaused">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <div v-else class="mb-3">
                    <i class="bx bx-pause-circle text-warning" style="font-size: 3rem;"></i>
                  </div>
                  <h5 v-if="!downloadPaused">Please wait while we download your records...</h5>
                  <h5 v-else class="text-warning">Download Paused</h5>

                  <!-- Estimated Time Remaining -->
                  <div v-if="downloadProgress.estimatedTimeRemaining && !downloadPaused" class="mt-2">
                    <p class="text-muted mb-1">
                      <i class="bx bx-time-five me-1"></i>
                      <strong>{{ formatTimeRemaining(downloadProgress.estimatedTimeRemaining) }}</strong> remaining
                    </p>
                    <small class="text-muted">
                      Average speed: {{ downloadProgress.averageSpeed }} records/sec
                    </small>
                  </div>

                  <p class="text-muted mt-2">{{ downloadPaused ? 'You can resume or cancel the download.' : 'This may take several minutes depending on the amount of data.' }}</p>
                </div>

                <div class="progress mb-3" style="height: 25px;">
                  <div
                      class="progress-bar progress-bar-striped"
                      :class="{'progress-bar-animated': !downloadPaused, 'bg-warning': downloadPaused}"
                      role="progressbar"
                      :style="{ width: downloadProgress.percentage + '%' }"
                      :aria-valuenow="downloadProgress.percentage"
                      aria-valuemin="0"
                      aria-valuemax="100">
                    {{ downloadProgress.percentage }}%
                  </div>
                </div>

                <div class="d-flex justify-content-between text-muted small mb-3">
                  <span>Page {{ downloadProgress.current }} of {{ downloadProgress.total }}</span>
                  <span>{{ downloadProgress.records }} / {{ numberFormat(downloadProgress.totalRecords) }} records</span>
                </div>

                <!-- Error Display -->
                <div v-if="downloadError" class="alert alert-danger d-flex align-items-center" role="alert">
                  <i class="bx bx-error-circle me-2"></i>
                  <div class="flex-grow-1">
                    <strong>Error:</strong> {{ downloadError }}
                    <br>
                    <small>You can retry from where it stopped or cancel the download.</small>
                  </div>
                </div>

                <!-- Retry Count Display -->
                <div v-if="downloadRetryCount > 0" class="alert alert-warning d-flex align-items-center mb-3" role="alert">
                  <i class="bx bx-info-circle me-2"></i>
                  <small>Retry attempt {{ downloadRetryCount }} of 3</small>
                </div>

                <!-- Action Buttons -->
                <div class="d-flex gap-2 justify-content-center mb-3">
                  <button
                      v-if="!downloadPaused && !downloadError"
                      @click="pauseDownload"
                      class="btn btn-warning btn-sm">
                    <i class="bx bx-pause me-1"></i>Pause
                  </button>
                  <button
                      v-if="downloadPaused || downloadError"
                      @click="resumeDownload"
                      class="btn btn-success btn-sm">
                    <i class="bx bx-play me-1"></i>Resume
                  </button>
                  <button
                      @click="cancelDownload"
                      class="btn btn-danger btn-sm">
                    <i class="bx bx-x me-1"></i>Cancel
                  </button>
                </div>

                <div class="alert alert-info d-flex align-items-center" role="alert">
                  <i class="bx bx-info-circle me-2"></i>
                  <small>{{ downloadPaused ? 'Download is paused. Your progress has been saved.' : 'Please do not close this window or navigate away.' }}</small>
                </div>

                <!-- Download Statistics -->
                <div v-if="downloadProgress.records > 0" class="mt-3 pt-3 border-top">
                  <div class="row text-center">
                    <div class="col-4">
                      <small class="text-muted d-block">Downloaded</small>
                      <strong>{{ numberFormat(downloadProgress.records) }}</strong>
                    </div>
                    <div class="col-4">
                      <small class="text-muted d-block">Remaining</small>
                      <strong>{{ numberFormat(downloadProgress.totalRecords - downloadProgress.records) }}</strong>
                    </div>
                    <div class="col-4">
                      <small class="text-muted d-block">Success Rate</small>
                      <strong>{{ getSuccessRate() }}%</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Bill Detail Modal -->
        <div
            class="modal fade"
            id="billDetail"
            tabindex="-1"
            aria-labelledby="billDetailLabel"
            aria-hidden="true"
        >
          <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="billDetailLabel">
                  <i class="bx bx-receipt me-2"></i>Bill Details
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <div class="bill-detail-header">
                  <div class="detail-info">
                    <h3 class="bill-number-large">{{currentBill.account_ref || currentBill.billNo || currentBill.transaction_code}}</h3>
                    <p class="bill-meta">Created on {{formatDate(currentBill.dateCreated || currentBill.date)}}</p>
                  </div>
                  <div class="detail-status">
                    <span class="status-badge-large" :class="getStatusClass(currentBill.status)">
                      {{currentBill.status || 'UNPAID'}}
                    </span>
                  </div>
                </div>

                <div class="bill-detail-customer">
                  <h6 class="section-title">Customer Information</h6>
                  <div class="customer-info">
                    <div class="info-item">
                      <span class="info-label">Name:</span>
                      <span class="info-value">{{getDisplayName(currentBill)}}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">ID Number:</span>
                      <span class="info-value">{{maskPhoneNumber(currentBill.idNo || currentBill.userIdNo) || 'N/A'}}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Phone:</span>
                      <span class="info-value">{{maskPhoneNumber(currentBill.customerPhoneNumber || currentBill.userPhoneNumber) || 'N/A'}}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Location:</span>
                      <span class="info-value">{{currentBill.subCountyName}} - {{currentBill.wardName}}</span>
                    </div>
                  </div>
                </div>

                <!-- Agent Information Section -->
                <div class="bill-detail-agents">
                  <h6 class="section-title">Processing Information</h6>
                  <div class="row">
                    <!-- Invoiced By Card -->
                    <div class="col-md-6 mb-3">
                      <div class="agent-card invoiced-card">
                        <div class="agent-card-header">
                          <i class="bx bx-file-blank"></i>
                          <span>Invoiced By</span>
                        </div>
                        <div class="agent-card-body">
                          <div class="agent-card-avatar invoiced">
                            {{getInitial(currentBill.invoicedBy || currentBill.username)}}
                          </div>
                          <div class="agent-card-details">
                            <h6 class="agent-card-name">{{currentBill.invoicedBy || currentBill.username || 'N/A'}}</h6>
                            <div class="agent-card-info">
                              <span v-if="currentBill.invoicedByIdNo || currentBill.userIdNo">
                                <i class="bx bx-id-card"></i> {{maskPhoneNumber(currentBill.invoicedByIdNo || currentBill.userIdNo)}}
                              </span>
                              <span v-if="currentBill.invoicedByPhoneNumber || currentBill.userPhoneNumber">
                                <i class="bx bx-phone"></i> {{maskPhoneNumber(currentBill.invoicedByPhoneNumber || currentBill.userPhoneNumber)}}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Receipted By Card -->
                    <div class="col-md-6 mb-3">
                      <div class="agent-card receipted-card">
                        <div class="agent-card-header">
                          <i class="bx bx-check-double"></i>
                          <span>Receipted By</span>
                        </div>
                        <div class="agent-card-body">
                          <div class="agent-card-avatar receipted">
                            {{getInitial(currentBill.receiptedBy || currentBill.username)}}
                          </div>
                          <div class="agent-card-details">
                            <h6 class="agent-card-name">{{currentBill.receiptedBy || currentBill.username || 'N/A'}}</h6>
                            <div class="agent-card-info">
                              <span v-if="currentBill.receiptedByIdNo || currentBill.userIdNo">
                                <i class="bx bx-id-card"></i> {{maskPhoneNumber(currentBill.receiptedByIdNo || currentBill.userIdNo)}}
                              </span>
                              <span v-if="currentBill.receiptedByPhoneNumber || currentBill.userPhoneNumber">
                                <i class="bx bx-phone"></i> {{maskPhoneNumber(currentBill.receiptedByPhoneNumber || currentBill.userPhoneNumber)}}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="bill-detail-items">
                  <h6 class="section-title">Transaction Details</h6>
                  <div class="table-responsive">
                    <table class="table table-modal">
                      <thead>
                      <tr>
                        <th width="15%">Transaction Code</th>
                        <th width="35%">Description</th>
                        <th width="16%" class="text-end">Invoice Amount</th>
                        <th width="16%" class="text-end">Paid Amount</th>
                        <th width="18%" class="text-end">Balance</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td>{{currentBill.transactionCode || currentBill.transaction_code || 'N/A'}}</td>
                        <td>{{currentBill.incomeTypeDescription || currentBill.transaction_desc || currentBill.description || 'N/A'}}</td>
                        <!-- INVOICED: use amount -->
                        <td class="text-end">{{formatPrice(currentBill.amount || 0)}}</td>
                        <!-- PAID: same as amount (always fully paid) -->
                        <td class="text-end">{{formatPrice(currentBill.amount || 0)}}</td>
                        <!-- BALANCE: always 0 -->
                        <td class="text-end fw-bold text-success">
                          {{formatPrice(0)}}
                        </td>
                      </tr>
                      </tbody>
                      <tfoot>
                      <tr class="table-total">
                        <td colspan="4" class="text-end fw-bold">Payment Method:</td>
                        <td class="text-end">
                          <span class="payment-method" :class="'payment-' + (currentBill.payment_type || '').toLowerCase()">
                            {{currentBill.payment_type || ''}}
                          </span>
                        </td>
                      </tr>
                      <tr class="table-total" v-if="currentBill.receiptNo || currentBill.transaction_code">
                        <td colspan="4" class="text-end fw-bold">Receipt / Transaction:</td>
                        <td class="text-end">
                          <span class="receipt-number">{{currentBill.receiptNo || currentBill.transaction_code}}</span>
                        </td>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary" @click="printReceipt(currentBill)">
                  <i class="bx bx-printer me-2"></i>Print Receipt
                </button>
              </div>
            </div>
          </div>
        </div>

        <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                © 2024 County Revenue System
              </div>
              <div class="col-sm-6">
                <div class="text-sm-end">Developed by County IT Department</div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import {authUrl, biller, execute, executeDownload, getRight} from "@/api";
import NavigationBar from "@/components/Navigation.vue";
import router from "@/router";
import moment from "moment";

export default {
  name: "Receipts",
  components: {NavigationBar},
  data() {
    return {
      // Filter states
      paymentMode: '',
      search: '',
      filter: '',
      selectedFilterValue: '',
      dateFrom: '',
      dateTo: '',

      // Loading states
      loading: false,
      downloading: false,
      searchTimeout: null,

      // Pagination
      currentPage: 1,
      totalPages: 1,
      pageSize: '25',

      // Data
      allBillDetails: [],
      filteredBillDetails: [],

      // Current selection
      currentBill: {},

      // Filter options
      itemList: [],
      filterLabel: '',

      // Summary
      summary: { count: 0, total: 0 },

      // Messages
      message: '',
      emptyStateMessage: 'There are no receipted bills to display.',

      // Download All functionality with pause/resume and time estimation
      isDownloadingAll: false,
      downloadPaused: false,
      downloadCancelled: false,
      downloadError: null,
      downloadRetryCount: 0,
      maxRetries: 3,
      downloadProgress: {
        current: 0,
        total: 0,
        percentage: 0,
        records: 0,
        totalRecords: 0,
        startTime: null,
        estimatedTimeRemaining: null,
        averageSpeed: 0
      },
      allRecordsData: [],
      downloadState: {
        startPage: 1,
        currentPage: 0,
        batchSize: 1000,
        totalPages: 0,
        accumulatedData: []
      }
    }
  },

  computed: {
    actualPageSize() {
      return this.pageSize === 'all' ? this.filteredBillDetails.length : parseInt(this.pageSize);
    },

    paginatedBillDetails() {
      if (this.pageSize === 'all') {
        return this.filteredBillDetails;
      }
      const start = (this.currentPage - 1) * this.actualPageSize;
      const end = start + this.actualPageSize;
      return this.filteredBillDetails.slice(start, end);
    },

    visiblePages() {
      return this.pagination(this.currentPage, this.totalPages, 5);
    },

    paginationStart() {
      if (this.filteredBillDetails.length === 0) return 0;
      return ((this.currentPage - 1) * this.actualPageSize) + 1;
    },

    paginationEnd() {
      if (this.pageSize === 'all') return this.filteredBillDetails.length;
      const end = this.currentPage * this.actualPageSize;
      return Math.min(end, this.filteredBillDetails.length);
    }
  },

  mounted() {
    this.dateFrom = moment().startOf('month').format('YYYY-MM-DD');
    this.dateTo = moment().format('YYYY-MM-DD');
    this.loadBills();
    this.checkMenuAccess();

    if (sessionStorage.getItem("filterType")) {
      this.filter = sessionStorage.getItem("filterType");
      this.handleFilterChange();
    }
  },

  watch: {
    filteredBillDetails() {
      this.calculatePagination();
    }
  },

  methods: {
    // ─── Utility ──────────────────────────────────────────────────────────────

    numberFormat(num) {
      return new Intl.NumberFormat("en-GB").format(num || 0);
    },

    formatPrice(value) {
      const num = parseFloat(value) || 0;
      return new Intl.NumberFormat('en-KE', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
      }).format(num);
    },

    formatDate(dateString) {
      if (!dateString) return 'N/A';
      return moment(dateString).format('DD MMM YYYY');
    },

    truncateText(text, maxLength) {
      if (!text) return 'N/A';
      if (text.length <= maxLength) return text;
      return text.substring(0, maxLength) + '...';
    },

    getInitial(name) {
      if (!name) return 'U';
      return name.charAt(0).toUpperCase();
    },

    /**
     * Resolve the best display name for a record.
     * API returns names="#" for some records; fall back to username in that case.
     */
    getDisplayName(item) {
      if (!item) return 'N/A';
      const raw = item.paidBy || item.names;
      if (raw && raw.trim() !== '#' && raw.trim() !== '') return raw;
      return item.customer || item.username || 'N/A';
    },

    maskPhoneNumber(input) {
      if (!input || typeof input !== 'string') return input;
      const digits = input.replace(/\D/g, '');
      if (digits.length > 4) {
        return input.slice(0, 2) +
            input.slice(2, -2).replace(/\d/g, '*') +
            input.slice(-2);
      }
      return input;
    },

    getStatusClass(status) {
      switch (status) {
        case 'PAID':    return 'status-paid';
        case 'PARTIAL': return 'status-partial';
        case 'PENDING': return 'status-pending';
        default:        return 'status-unpaid';
      }
    },

    // ─── Amount helpers ────────────────────────────────────────────────────────

    /**
     * Balance is always 0 — this API returns fully-paid transactions only.
     */
    getBalance(item) {
      return 0;
    },

    /**
     * Total balance across all filtered items is always 0.
     */
    calculateTotalBalance() {
      return 0;
    },

    /**
     * Sum a field across filteredBillDetails.
     * Both 'detailAmount' and 'receiptAmount' are mapped to the real 'amount' field.
     */
    calculateTotal(field) {
      return this.filteredBillDetails.reduce((sum, item) => {
        // Always read from 'amount' — the only reliable monetary field in this API
        return sum + (parseFloat(item.amount) || 0);
      }, 0);
    },

    calculateAverage(field) {
      if (this.filteredBillDetails.length === 0) return 0;
      return this.calculateTotal(field) / this.filteredBillDetails.length;
    },

    // ─── Time estimation ───────────────────────────────────────────────────────

    formatTimeRemaining(seconds) {
      if (!seconds || seconds <= 0) return 'Calculating...';
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = Math.floor(seconds % 60);
      if (hours > 0) return `${hours}h ${minutes}m ${secs}s`;
      if (minutes > 0) return `${minutes}m ${secs}s`;
      return `${secs}s`;
    },

    calculateEstimatedTime() {
      if (!this.downloadProgress.startTime || this.downloadProgress.current === 0) return;
      const elapsedTime = (Date.now() - this.downloadProgress.startTime) / 1000;
      const recordsDownloaded = this.downloadProgress.records;
      const remainingRecords = this.downloadProgress.totalRecords - recordsDownloaded;
      if (recordsDownloaded > 0 && elapsedTime > 0) {
        const averageSpeed = recordsDownloaded / elapsedTime;
        this.downloadProgress.averageSpeed = averageSpeed.toFixed(2);
        this.downloadProgress.estimatedTimeRemaining = remainingRecords / averageSpeed;
      }
    },

    getSuccessRate() {
      if (this.downloadProgress.total === 0) return 100;
      const successfulPages = this.downloadProgress.current - this.downloadRetryCount;
      return Math.round((successfulPages / this.downloadProgress.total) * 100);
    },

    // ─── Download pause / resume / cancel ─────────────────────────────────────

    pauseDownload() {
      this.downloadPaused = true;
    },

    async resumeDownload() {
      this.downloadPaused = false;
      this.downloadError = null;
      this.downloadRetryCount = 0;
      await this.continueDownload();
    },

    cancelDownload() {
      if (confirm('Are you sure you want to cancel the download? All progress will be lost.')) {
        this.downloadCancelled = true;
        this.closeDownloadModal();
      }
    },

    closeDownloadModal() {
      const modalElement = document.getElementById('downloadProgressModal');
      if (modalElement) {
        const existingModal = bootstrap.Modal.getInstance(modalElement);
        if (existingModal) existingModal.hide();
      }
      document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';

      this.isDownloadingAll = false;
      this.downloadPaused = false;
      this.downloadCancelled = false;
      this.downloadError = null;
      this.downloadRetryCount = 0;
      this.allRecordsData = [];
      this.downloadProgress = {
        current: 0, total: 0, percentage: 0, records: 0,
        totalRecords: 0, startTime: null, estimatedTimeRemaining: null, averageSpeed: 0
      };
      this.downloadState = {
        startPage: 1, currentPage: 0, batchSize: 1000, totalPages: 0, accumulatedData: []
      };
    },

    // ─── Data loading ──────────────────────────────────────────────────────────

    async loadBills() {
      this.loading = true;
      this.allBillDetails = [];
      this.filteredBillDetails = [];

      try {
        const data = new FormData();
        data.append("function", "getReceiptsDetailsPaginated");
        data.append("page", 1);
        data.append("rows_per_page", 10000);
        data.append("status", "PAID");

        if (this.dateFrom)            data.append("dateFrom", this.dateFrom);
        if (this.dateTo)              data.append("dateTo", this.dateTo);
        if (this.paymentMode)         data.append("payment_method", this.paymentMode);
        if (this.search)              data.append("keyword", this.search);

        if (this.selectedFilterValue) {
          switch (this.filter) {
            case 'filter-sub-county': data.append("subCountyID", this.selectedFilterValue); break;
            case 'filter-wards':      data.append("wardID",      this.selectedFilterValue); break;
            case 'filter-zone':       data.append("zone",        this.selectedFilterValue); break;
            case 'filter-officer':    data.append("createdBy",   this.selectedFilterValue); break;
          }
        }

        const response = await execute(data, biller);

        if (response.data.success) {
          this.allBillDetails      = response.data.data.billDetails || [];
          this.filteredBillDetails = [...this.allBillDetails];
          this.summary             = response.data.data.summary || { count: 0, total: 0 };
          if (this.allBillDetails.length === 0) this.emptyStateMessage = 'No receipt data available.';
        } else {
          this.message = response.data.message || 'Failed to load bills';
          this.showToast(this.message, 'error');
        }
      } catch (error) {
        console.error('Error loading bills:', error);
        this.message = error.message || 'An error occurred while loading bills';
        this.showToast(this.message, 'error');
      } finally {
        this.loading = false;
      }
    },

    applyFilters() {
      this.loadBills();
    },

    calculatePagination() {
      this.totalPages = this.pageSize === 'all'
          ? 1
          : Math.ceil(this.filteredBillDetails.length / this.actualPageSize);
    },

    debounceSearch() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => { this.applyFilters(); }, 500);
    },

    clearSearch() {
      this.search = '';
      this.applyFilters();
    },

    async handleFilterChange() {
      this.selectedFilterValue = '';
      this.itemList = [];
      if (!this.filter) { this.applyFilters(); return; }
      this.extractFilterOptions();
      this.applyFilters();
    },

    extractFilterOptions() {
      const uniqueValues = new Set();
      switch (this.filter) {
        case 'filter-sub-county':
          this.filterLabel = 'Sub County';
          this.allBillDetails.forEach(item => { if (item.subCountyName) uniqueValues.add(item.subCountyName); });
          break;
        case 'filter-wards':
          this.filterLabel = 'Ward';
          this.allBillDetails.forEach(item => { if (item.wardName) uniqueValues.add(item.wardName); });
          break;
        case 'filter-zone':
          this.filterLabel = 'Zone';
          this.allBillDetails.forEach(item => { if (item.zoneName) uniqueValues.add(item.zoneName); });
          break;
        case 'filter-officer':
          this.filterLabel = 'Agent';
          this.allBillDetails.forEach(item => {
            if (item.invoicedBy)  uniqueValues.add(item.invoicedBy);
            if (item.receiptedBy) uniqueValues.add(item.receiptedBy);
            if (item.username)    uniqueValues.add(item.username);
          });
          break;
      }
      this.itemList = Array.from(uniqueValues).sort().map((value, index) => ({ id: index + 1, value }));
    },

    // ─── CSV download ──────────────────────────────────────────────────────────

    downloadCurrentView() {
      this.downloading = true;
      try {
        const csvData = this.generateCSV(this.filteredBillDetails);
        this.downloadCSV(csvData, this.generateFilename('Filtered_Receipts'));
        this.showToast(`Downloaded ${this.filteredBillDetails.length} filtered receipts`, 'success');
      } catch (error) {
        console.error('Download error:', error);
        this.showToast('Failed to download current view', 'error');
      } finally {
        this.downloading = false;
      }
    },

    async downloadAllData() {
      if (!this.dateFrom || !this.dateTo) {
        this.showToast('Please select date range before downloading', 'warning');
        return;
      }

      const isConfirmed = confirm(
          `You are about to download all ${this.numberFormat(this.summary.count)} receipts from ${this.dateFrom} to ${this.dateTo}. This may take several minutes. Do you want to continue?`
      );
      if (!isConfirmed) return;

      this.isDownloadingAll = true;
      this.downloadPaused = false;
      this.downloadCancelled = false;
      this.downloadError = null;
      this.downloadRetryCount = 0;
      this.allRecordsData = [];

      const batchSize    = 1000;
      const totalRecords = this.summary.count;
      const totalPages   = Math.ceil(totalRecords / batchSize);

      this.downloadState = { startPage: 1, currentPage: 0, batchSize, totalPages, accumulatedData: [] };
      this.downloadProgress = {
        current: 0, total: totalPages, percentage: 0,
        records: 0, totalRecords, startTime: Date.now(),
        estimatedTimeRemaining: null, averageSpeed: 0
      };

      const modalElement  = document.getElementById('downloadProgressModal');
      const progressModal = new bootstrap.Modal(modalElement);
      progressModal.show();

      await this.continueDownload();
    },

    async continueDownload() {
      try {
        const startPage  = this.downloadState.currentPage + 1;
        const totalPages = this.downloadState.totalPages;

        for (let page = startPage; page <= totalPages; page++) {
          if (this.downloadPaused)   return;
          if (this.downloadCancelled) return;

          try {
            this.downloadState.currentPage     = page;
            this.downloadProgress.current      = page;
            this.downloadProgress.percentage   = Math.round((page / totalPages) * 100);

            const pageData = await this.fetchReceiptsPageWithRetry(page, this.downloadState.batchSize);

            if (pageData && pageData.length > 0) {
              this.downloadState.accumulatedData = [...this.downloadState.accumulatedData, ...pageData];
              this.allRecordsData                = this.downloadState.accumulatedData;
              this.downloadProgress.records      = this.allRecordsData.length;
              this.calculateEstimatedTime();
            }

            this.downloadRetryCount = 0;
            this.downloadError      = null;
            await this.delay(50);

          } catch (error) {
            console.error(`Error fetching page ${page}:`, error);
            this.downloadError  = error.message;
            this.downloadPaused = true;
            return;
          }
        }

        await this.finalizeDownload();

      } catch (error) {
        console.error('Download error:', error);
        this.downloadError  = error.message;
        this.downloadPaused = true;
      }
    },

    async fetchReceiptsPageWithRetry(page, rowsPerPage, retryCount = 0) {
      try {
        const data = new FormData();
        data.append("function", "getReceiptsDetailsPaginated");
        data.append("page", page);
        data.append("rows_per_page", rowsPerPage);
        data.append("status", "PAID");

        if (this.dateFrom)            data.append("dateFrom", this.dateFrom);
        if (this.dateTo)              data.append("dateTo",   this.dateTo);
        if (this.paymentMode)         data.append("payment_method", this.paymentMode);
        if (this.search)              data.append("keyword",  this.search);

        if (this.selectedFilterValue) {
          switch (this.filter) {
            case 'filter-sub-county': data.append("subCountyID", this.selectedFilterValue); break;
            case 'filter-wards':      data.append("wardID",      this.selectedFilterValue); break;
            case 'filter-zone':       data.append("zone",        this.selectedFilterValue); break;
            case 'filter-officer':    data.append("createdBy",   this.selectedFilterValue); break;
          }
        }

        const res = await execute(data, biller);
        if (res.data.success) return res.data.data.billDetails || [];
        throw new Error(res.data.message || 'Failed to fetch page data');

      } catch (error) {
        if (retryCount < this.maxRetries) {
          this.downloadRetryCount = retryCount + 1;
          await this.delay(Math.pow(2, retryCount) * 1000);
          return this.fetchReceiptsPageWithRetry(page, rowsPerPage, retryCount + 1);
        }
        throw new Error(`Failed after ${this.maxRetries} retries: ${error.message}`);
      }
    },

    async finalizeDownload() {
      if (this.allRecordsData.length > 0) {
        const csv      = this.generateCSV(this.allRecordsData);
        const blob     = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link     = document.createElement('a');
        const url      = URL.createObjectURL(blob);
        const fileName = this.generateFilename('All_Receipts');

        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        await this.delay(500);
        this.showToast(`Successfully downloaded ${this.allRecordsData.length} receipts!`, 'success');
        this.closeDownloadModal();
      } else {
        this.showToast('No records found to download', 'info');
        this.closeDownloadModal();
      }
    },

    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    /**
     * Generate CSV — uses `amount` for both Invoice Amount and Paid Amount;
     * Balance is always 0.
     */
    generateCSV(data) {
      const headers = [
        'Bill Number',
        'Transaction Code',
        'Description',
        'Paid By',
        'Sub County',
        'Ward',
        'Invoiced By',
        'Invoiced By ID',
        'Invoiced By Phone',
        'Receipted By',
        'Receipted By ID',
        'Receipted By Phone',
        'Invoice Amount',
        'Paid Amount',
        'Balance',
        'Payment Method',
        'Status',
        'Date Created',
        'Customer ID Number',
        'Customer Phone'
      ];

      const rows = data.map(item => {
        const txAmount = parseFloat(item.amount) || 0;

        return [
          this.escapeCSVField(item.account_ref || item.billNo || ''),
          this.escapeCSVField(item.transactionCode || item.transaction_code || ''),
          this.escapeCSVField(item.incomeTypeDescription || item.transaction_desc || ''),
          this.escapeCSVField(this.getDisplayName(item)),
          this.escapeCSVField(item.subCountyName || ''),
          this.escapeCSVField(item.wardName || ''),
          this.escapeCSVField(item.invoicedBy || item.username || ''),
          this.escapeCSVField(item.invoicedByIdNo || item.userIdNo || ''),
          this.escapeCSVField(item.invoicedByPhoneNumber || item.userPhoneNumber || ''),
          this.escapeCSVField(item.receiptedBy || item.username || ''),
          this.escapeCSVField(item.receiptedByIdNo || item.userIdNo || ''),
          this.escapeCSVField(item.receiptedByPhoneNumber || item.userPhoneNumber || ''),
          this.formatPriceForCSV(txAmount),   // Invoice Amount
          this.formatPriceForCSV(txAmount),   // Paid Amount (same — always fully paid)
          this.formatPriceForCSV(0),          // Balance (always 0)
          this.escapeCSVField(item.payment_type || ''),
          this.escapeCSVField(item.status || ''),
          this.formatDateForCSV(item.dateCreated || item.date),
          this.escapeCSVField(item.idNo || item.userIdNo || ''),
          this.escapeCSVField(item.customerPhoneNumber || item.userPhoneNumber || '')
        ];
      });

      return [headers, ...rows].map(row => row.join(',')).join('\n');
    },

    escapeCSVField(field) {
      if (field == null) return '';
      const str = String(field);
      if (str.includes(',') || str.includes('"') || str.includes('\n') || str.includes('\r')) {
        return '"' + str.replace(/"/g, '""') + '"';
      }
      return str;
    },

    formatPriceForCSV(value) {
      return (parseFloat(value) || 0).toFixed(2);
    },

    formatDateForCSV(dateString) {
      if (!dateString) return '';
      return moment(dateString).format('DD/MM/YYYY HH:mm:ss');
    },

    generateFilename(prefix) {
      let filename = prefix;
      if (this.dateFrom && this.dateTo) filename += `_${this.dateFrom}_to_${this.dateTo}`;
      if (this.paymentMode)             filename += `_${this.paymentMode}`;
      if (this.selectedFilterValue)     filename += `_${this.selectedFilterValue.replace(/\s+/g, '_')}`;
      filename += `_${moment().format('YYYY-MM-DD_HHmmss')}.csv`;
      return filename;
    },

    downloadCSV(csvContent, filename) {
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url  = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },

    // ─── Bill detail modal ─────────────────────────────────────────────────────

    viewBillDetails(item) {
      this.currentBill = { ...item };
      if (item.account_ref || item.billNo) {
        this.loadBillDetails(item.account_ref || item.billNo, item.transactionCode);
      }
    },

    async loadBillDetails(billNo, transactionCode) {
      try {
        const data = new FormData();
        data.append("function", "getBill");
        data.append("billNo", billNo);
        if (transactionCode) data.append("transactionCode", transactionCode);

        const response = await execute(data, biller);
        if (response.data.success) {
          Object.assign(this.currentBill, response.data.data.billDetails);
        }
      } catch (error) {
        console.error('Error loading bill details:', error);
      }
    },

    // ─── Print ─────────────────────────────────────────────────────────────────

    printBill(billNo) {
      if (!billNo) return;
      localStorage['params'] = JSON.stringify({ billNo });
      const routeData = this.$router.resolve({ name: 'bill' });
      window.open(routeData.href, '_blank');
    },

    printReceipt(bill) {
      if (!bill.transactionCode && !bill.transaction_code && !bill.receiptNo) {
        this.showToast('Receipt number not available', 'warning');
        return;
      }
      localStorage['params'] = JSON.stringify({
        receiptNo: bill.receiptNo || bill.transactionCode || bill.transaction_code,
        billNo:    bill.account_ref || bill.billNo
      });
      const routeData = this.$router.resolve({ name: 'receipt' });
      window.open(routeData.href, '_blank');
    },

    // ─── Actions ───────────────────────────────────────────────────────────────

    sendEmail(item) {
      console.log('Send email for', item);
      this.showToast('Email functionality coming soon', 'info');
    },

    sendSMS(item) {
      console.log('Send SMS for', item);
      this.showToast('SMS functionality coming soon', 'info');
    },

    async voidReceipt(item) {
      if (!confirm(`Are you sure you want to void receipt ${item.transactionCode || item.transaction_code || item.receiptNo}?`)) return;
      try {
        const data = new FormData();
        data.append("function", "voidReceipt");
        data.append("receiptNo", item.receiptNo || item.transactionCode || item.transaction_code);
        data.append("reason", "Voided by user");

        const response = await execute(data, biller);
        if (response.data.success) {
          this.showToast('Receipt voided successfully', 'success');
          this.loadBills();
        } else {
          this.showToast(response.data.message || 'Failed to void receipt', 'error');
        }
      } catch (error) {
        console.error('Error voiding receipt:', error);
        this.showToast('An error occurred while voiding receipt', 'error');
      }
    },

    // ─── Pagination ────────────────────────────────────────────────────────────

    handlePageSizeChange() {
      this.currentPage = 1;
      this.calculatePagination();
    },

    goToFirstPage() { if (this.currentPage !== 1) this.currentPage = 1; },
    goToLastPage()  { if (this.currentPage !== this.totalPages) this.currentPage = this.totalPages; },
    prevPage()      { if (this.currentPage > 1) this.currentPage--; },
    nextPage()      { if (this.currentPage < this.totalPages) this.currentPage++; },

    goToPage(page) {
      if (page !== '...' && page !== this.currentPage) this.currentPage = page;
    },

    pagination(currentPage, totalPages, maxVisibleButtons) {
      let pages = [];
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end   = currentPage + Math.floor(maxVisibleButtons / 2);

      if (start < 1) { start = 1; end = Math.min(start + maxVisibleButtons - 1, totalPages); }
      if (end > totalPages) { end = totalPages; start = Math.max(end - maxVisibleButtons + 1, 1); }

      for (let i = start; i <= end; i++) pages.push(i);
      if (start > 1)        { pages.unshift("..."); pages.unshift(1); }
      if (end < totalPages) { pages.push("..."); pages.push(totalPages); }

      return pages;
    },

    // ─── Misc ──────────────────────────────────────────────────────────────────

    showToast(message, type = 'info') {
      console.log(`[${type.toUpperCase()}]:`, message);
    },

    checkMenuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Receipt Payment");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, biller)
          .then(response => { if (!response.data.success) this.$router.push('/dashboard'); })
          .catch(error   => { console.error('Menu access check failed:', error); });
    },

    getRight(type) { return getRight(type); },
    gotTo(route)   { this.$router.push(route); }
  }
}
</script>

<style scoped>
/* Enhanced Header Section */
.page-header-enhanced {
  background: linear-gradient(135deg, #0891b2 0%, #06b6d4 50%, #0ea5e9 100%);
  padding: 1.5rem;
  border-radius: 12px;
  margin-bottom: 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
}

.page-header-enhanced::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%);
  animation: shimmer 15s infinite linear;
}

@keyframes shimmer {
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.header-content-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.header-left  { flex: 1; }

.page-main-title {
  color: white;
  font-size: 1.75rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
}

.breadcrumb-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.875rem;
}

.breadcrumb-container i { font-size: 1rem; }

.breadcrumb-link {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  cursor: pointer;
  transition: color 0.3s;
}
.breadcrumb-link:hover { color: white; }
.breadcrumb-divider    { color: rgba(255, 255, 255, 0.6); margin: 0 0.25rem; }
.breadcrumb-current    { color: white; }

.header-right { display: flex; gap: 1rem; }

.header-stat-badge {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  padding: 0.75rem 1.25rem;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.header-stat-badge.primary { background: rgba(255, 255, 255, 0.25); }

.stat-number {
  color: white;
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1;
}
.stat-text {
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.625rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 0.25rem;
}

/* Summary Cards */
.summary-cards-row { margin-bottom: 1.5rem; }

.summary-card {
  background: white;
  border-radius: 12px;
  padding: 1.25rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  gap: 1rem;
  transition: all 0.3s;
  margin-bottom: 1rem;
  position: relative;
  overflow: hidden;
}
.summary-card::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 4px;
}
.purple-gradient::before { background: linear-gradient(90deg, #0891b2 0%, #06b6d4 100%); }
.blue-gradient::before   { background: linear-gradient(90deg, #3b82f6 0%, #60a5fa 100%); }
.green-gradient::before  { background: linear-gradient(90deg, #10b981 0%, #34d399 100%); }
.orange-gradient::before { background: linear-gradient(90deg, #f59e0b 0%, #fbbf24 100%); }

.summary-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}

.card-icon-box {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
}
.purple-gradient .card-icon-box { background: rgba(8, 145, 178, 0.1);  color: #0891b2; }
.blue-gradient   .card-icon-box { background: rgba(59, 130, 246, 0.1); color: #3b82f6; }
.green-gradient  .card-icon-box { background: rgba(16, 185, 129, 0.1); color: #10b981; }
.orange-gradient .card-icon-box { background: rgba(245, 158, 11, 0.1); color: #f59e0b; }

.card-content { flex: 1; }
.card-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 0.25rem 0;
}
.card-label {
  font-size: 0.625rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0;
}

/* Main Table Card */
.main-table-card {
  border: none;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

/* Filter Section */
.filter-header {
  background: white;
  border-bottom: 1px solid #e5e7eb;
  padding: 1.25rem;
}
.filter-row { display: flex; flex-direction: column; gap: 1rem; }

.search-container { width: 100%; max-width: 400px; }

.search-input-wrapper { position: relative; display: flex; align-items: center; }
.search-input-wrapper i {
  position: absolute;
  left: 1rem;
  color: #6b7280;
  pointer-events: none;
}
.search-field {
  padding-left: 2.75rem;
  padding-right: 2.75rem;
  height: 42px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 0.875rem;
  width: 100%;
}
.search-field:focus {
  border-color: #0891b2;
  box-shadow: 0 0 0 3px rgba(8, 145, 178, 0.1);
  outline: none;
}
.btn-clear-search {
  position: absolute;
  right: 0.5rem;
  background: transparent;
  border: none;
  padding: 0.5rem;
  color: #6b7280;
  cursor: pointer;
  transition: color 0.3s;
}
.btn-clear-search:hover { color: #ef4444; }

.filter-controls-wrapper { display: flex; flex-wrap: wrap; gap: 1rem; align-items: flex-end; }
.filter-item { display: flex; flex-direction: column; gap: 0.375rem; min-width: 140px; }
.filter-label {
  font-size: 0.625rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.filter-select, .date-input {
  height: 38px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 0.875rem;
  padding: 0 0.75rem;
}
.filter-select:focus, .date-input:focus {
  border-color: #0891b2;
  box-shadow: 0 0 0 3px rgba(8, 145, 178, 0.1);
  outline: none;
}
.date-range-item  { min-width: 280px; }
.date-range-inputs { display: flex; align-items: center; gap: 0.5rem; }
.date-separator    { color: #6b7280; font-size: 0.875rem; }

.download-buttons-group { display: flex; gap: 0.5rem; }

.btn-download {
  height: 38px;
  padding: 0 1.25rem;
  background: linear-gradient(135deg, #0891b2 0%, #06b6d4 100%);
  border: none;
  border-radius: 6px;
  color: white;
  font-size: 0.875rem;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  transition: all 0.3s;
  margin-top: 1.375rem;
}
.btn-download:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(8, 145, 178, 0.3);
}
.btn-download:disabled { opacity: 0.6; cursor: not-allowed; }

/* Table Styles */
.bills-table { width: 100%; margin-bottom: 0; }
.bills-table thead {
  background: #f9fafb;
  border-bottom: 2px solid #e5e7eb;
}
.bills-table thead th {
  padding: 0.75rem 0.5rem;
  font-size: 0.625rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border: none;
}
.bills-table tbody tr {
  border-bottom: 1px solid #f3f4f6;
  transition: background-color 0.2s;
}
.bills-table tbody tr:hover { background-color: #f9fafb; }
.bills-table tbody td {
  padding: 0.75rem 0.5rem;
  vertical-align: middle;
  font-size: 0.8125rem;
  color: #374151;
}

.row-number { font-weight: 500; color: #6b7280; }

.bill-no-cell   { display: flex; flex-direction: column; gap: 0.125rem; }
.bill-number {
  font-weight: 600;
  color: #0891b2;
  cursor: pointer;
  transition: color 0.3s;
  font-size: 0.75rem;
}
.bill-number:hover { color: #06b6d4; text-decoration: underline; }
.transaction-code { font-size: 0.6875rem; color: #9ca3af; font-family: monospace; }

.description-text {
  display: block;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.8125rem;
}

.user-info-cell  { display: flex; align-items: center; gap: 0.5rem; }
.user-avatar {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: linear-gradient(135deg, #7c3aed 0%, #a855f7 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.6875rem;
  font-weight: 600;
  flex-shrink: 0;
}
.user-name {
  font-weight: 500;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.8125rem;
}

.location-info { display: flex; flex-direction: column; gap: 0.125rem; }
.location-main { font-weight: 500; font-size: 0.8125rem; }
.location-sub  { font-size: 0.6875rem; color: #9ca3af; }

.agent-info-cell { display: flex; align-items: center; gap: 0.5rem; }
.agent-avatar {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.6875rem;
  font-weight: 600;
  flex-shrink: 0;
}
.agent-avatar.invoiced  { background: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%); }
.agent-avatar.receipted { background: linear-gradient(135deg, #10b981 0%, #34d399 100%); }

.agent-details { display: flex; flex-direction: column; gap: 0.0625rem; min-width: 0; }
.agent-name {
  font-weight: 500;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.8125rem;
}
.agent-phone { font-size: 0.6875rem; color: #9ca3af; }

.invoice-amount { font-weight: 600; color: #3b82f6;  font-size: 0.875rem; }
.paid-amount    { font-weight: 700; color: #10b981;  font-size: 0.875rem; }
.balance-amount { font-weight: 600; color: #6b7280;  font-size: 0.875rem; }
.balance-amount.has-balance { color: #ef4444; font-weight: 700; }

.payment-method {
  display: inline-flex;
  align-items: center;
  padding: 0.1875rem 0.5rem;
  border-radius: 4px;
  font-size: 0.625rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.payment-mpesa { background: rgba(16, 185, 129, 0.1); color: #10b981; }
.payment-bank  { background: rgba(59, 130, 246, 0.1); color: #3b82f6; }
.payment-cash  { background: rgba(245, 158, 11, 0.1); color: #f59e0b; }

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.1875rem;
  padding: 0.1875rem 0.5rem;
  border-radius: 4px;
  font-size: 0.625rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.status-badge i { font-size: 0.5rem; }
.status-paid    { background: rgba(16, 185, 129, 0.1); color: #10b981; }
.status-partial { background: rgba(245, 158, 11, 0.1); color: #f59e0b; }
.status-pending { background: rgba(59, 130, 246, 0.1); color: #3b82f6; }
.status-unpaid  { background: rgba(239, 68, 68, 0.1);  color: #ef4444; }

.date-text { font-weight: 500; color: #6b7280; font-size: 0.75rem; }

.action-buttons { display: flex; gap: 0.25rem; justify-content: center; }
.btn-icon {
  width: 26px;
  height: 26px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  font-size: 0.8125rem;
}

/* Loading & Empty States */
.loading-state, .empty-state { padding: 4rem 2rem; text-align: center; }
.empty-icon { font-size: 4rem; color: #e5e7eb; margin-bottom: 1rem; }
.loading-state h4, .empty-state h3 { color: #374151; margin-bottom: 0.5rem; }
.loading-state p,  .empty-state p  { color: #6b7280; font-size: 0.875rem; }

/* Pagination */
.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1rem 1.25rem;
  background: #f9fafb;
}
.pagination-info {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 0.875rem;
  color: #6b7280;
}
.page-size-select {
  width: auto;
  height: 32px;
  padding: 0 2rem 0 0.75rem;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 0.875rem;
}
.pagination { margin: 0; display: flex; gap: 0.25rem; }
.page-item .page-link {
  padding: 0.375rem 0.625rem;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  color: #6b7280;
  font-size: 0.875rem;
  cursor: pointer;
  background: white;
  transition: all 0.2s;
  min-width: 32px;
  text-align: center;
}
.page-item .page-link:hover      { background: #0891b2; color: white; border-color: #0891b2; }
.page-item.active .page-link     { background: #0891b2; color: white; border-color: #0891b2; }
.page-item.disabled .page-link   { opacity: 0.5; cursor: not-allowed; pointer-events: none; }

/* Modal Styles */
.modal-content {
  border: none;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}
.modal-header {
  background: linear-gradient(135deg, #0891b2 0%, #06b6d4 100%);
  color: white;
  border: none;
  border-radius: 12px 12px 0 0;
  padding: 1.25rem 1.5rem;
}
.modal-title { font-weight: 600; display: flex; align-items: center; }
.modal-title i { margin-right: 0.5rem; }
.btn-close { color: white; opacity: 0.8; filter: brightness(0) invert(1); }
.btn-close:hover { opacity: 1; }
.modal-body { padding: 1.5rem; }

.bill-detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 1rem;
  border-bottom: 2px solid #e5e7eb;
  margin-bottom: 1.5rem;
}
.bill-number-large { font-size: 1.5rem; color: #0891b2; margin-bottom: 0.25rem; }
.bill-meta         { font-size: 0.875rem; color: #6b7280; margin: 0; }

.status-badge-large {
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.875rem;
}
.status-badge-large.status-paid    { background: rgba(16, 185, 129, 0.1); color: #10b981; }
.status-badge-large.status-unpaid  { background: rgba(239, 68, 68, 0.1);  color: #ef4444; }
.status-badge-large.status-partial { background: rgba(245, 158, 11, 0.1); color: #f59e0b; }

.bill-detail-customer { margin-bottom: 1.5rem; }
.section-title {
  font-size: 0.875rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #6b7280;
  margin-bottom: 1rem;
  letter-spacing: 0.5px;
}
.customer-info { background: #f9fafb; padding: 1rem; border-radius: 8px; }
.info-item { display: flex; margin-bottom: 0.5rem; }
.info-item:last-child { margin-bottom: 0; }
.info-item .info-label  { font-weight: 600; margin-right: 0.5rem; min-width: 100px; color: #6b7280; }
.info-item .info-value  { color: #374151; }

/* Agent Cards */
.bill-detail-agents { margin-bottom: 1.5rem; }
.agent-card {
  background: #f9fafb;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  transition: all 0.3s;
}
.agent-card:hover { box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08); }
.agent-card-header {
  padding: 0.75rem 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.invoiced-card  .agent-card-header { background: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%); color: white; }
.receipted-card .agent-card-header { background: linear-gradient(135deg, #10b981 0%, #34d399 100%); color: white; }

.agent-card-body { padding: 1rem; display: flex; align-items: center; gap: 1rem; }
.agent-card-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  font-weight: 700;
  flex-shrink: 0;
}
.agent-card-avatar.invoiced  { background: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%); }
.agent-card-avatar.receipted { background: linear-gradient(135deg, #10b981 0%, #34d399 100%); }

.agent-card-details { flex: 1; min-width: 0; }
.agent-card-name {
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 0.375rem 0;
  font-size: 0.9375rem;
}
.agent-card-info { display: flex; flex-direction: column; gap: 0.25rem; }
.agent-card-info span { display: flex; align-items: center; gap: 0.375rem; font-size: 0.8125rem; color: #6b7280; }
.agent-card-info i { font-size: 0.875rem; color: #9ca3af; }

.receipt-number { font-family: monospace; font-weight: 600; color: #0891b2; }

.table-modal       { margin-bottom: 0; }
.table-modal thead { background: #f9fafb; }
.table-modal thead th {
  padding: 0.75rem;
  font-size: 0.8125rem;
  font-weight: 600;
  text-transform: uppercase;
  color: #6b7280;
  border: none;
}
.table-modal tbody td { padding: 0.75rem; font-size: 0.875rem; border-top: 1px solid #e5e7eb; }
.table-total         { background: #f9fafb; }
.table-total td      { padding: 1rem 0.75rem; border-top: 2px solid #e5e7eb; }

.modal-footer {
  background: #f9fafb;
  border-top: 1px solid #e5e7eb;
  border-radius: 0 0 12px 12px;
  padding: 1rem 1.5rem;
}

/* Responsive */
@media (max-width: 768px) {
  .header-content-wrapper { flex-direction: column; align-items: flex-start; }
  .header-right            { width: 100%; justify-content: space-between; }
  .filter-controls-wrapper { flex-direction: column; width: 100%; }
  .filter-item, .date-range-item { width: 100%; }
  .pagination-wrapper      { flex-direction: column; }
  .pagination-info         { width: 100%; justify-content: space-between; }
  .agent-card-body         { flex-direction: column; text-align: center; }
}
</style>